import React, { useState, useEffect } from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, LabelList } from 'recharts';
import authService from '../../Services/authService';

const MyLineChart = ({ organizationId, filterType }) => {
  const [chartData, setChartData] = useState([]);
  const [isMobile, setIsMobile] = useState(false);

  // Fetch chart data
  useEffect(() => {
    if (!organizationId) return;

    const fetchChartData = async () => {
      const token = authService.getCurrentadmin().token;
      try {
        const response = await fetch(authService.getApiUrl() + 'filterorders', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            organization_id: organizationId,
            filter_type: filterType
          })
        });
        const result = await response.json();

        // Assuming API returns array like:
        // [{ date: "2025-06-15", cash: 1000, online: 2000 }, ...]
        const formattedData = result.data.map(item => ({
          time: item.date,  // or format as "June 15" etc.
          cash: item.cash_collection,
          online: item.online_sales
        }));
        setChartData(formattedData);
      } catch (err) {
        console.error("Failed to load chart data:", err);
      }
    };

    fetchChartData();
  }, [organizationId, filterType]);

  // Handle mobile responsiveness
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Compute max Y value for dynamic scaling
  const maxDataValue = Math.max(...chartData.map(d => (d.online || 0) + (d.cash || 0)), 0);
  const adjustedMaxValue = maxDataValue * 1.5;

  return (
    <div className='graph-cont'>
      <ResponsiveContainer width="100%" height={isMobile ? 350 : 450}>
        <BarChart
          data={chartData}
          margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
          barSize={isMobile ? 20 : 58}
        >
          <XAxis
            dataKey="time"
            tick={{
              angle: isMobile ? -45 : 0,
              textAnchor: isMobile ? 'end' : 'middle',
              fontSize: isMobile ? 8 : 12
            }}
            interval={0}
          />
          {!isMobile && <YAxis domain={[0, adjustedMaxValue]} />}
          <Tooltip />
          <Bar dataKey="cash" fill="#5d79ff" stackId="a" />
          <Bar dataKey="online" fill="#febd59" stackId="a" radius={[10, 10, 0, 0]}>
            <LabelList
              dataKey="online"
              position="top"
              content={({ x, y, width, value, index }) => {
                const cash = chartData[index]?.cash || 0;
                const total = cash + (value || 0);
                const adjustedY = y > 20 ? y - 10 : y + 10;
                return (
                  <text
                    x={x + width / 2}
                    y={adjustedY}
                    fill="#343434"
                    fontSize={isMobile ? "8px" : "10px"}
                    textAnchor="middle"
                    dominantBaseline="middle"
                  >
                    ₹{total}
                  </text>
                );
              }}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default MyLineChart;
